const STORAGE_KEYS = {
  wsUrl: "aaria.wsUrl",
  operatorName: "aaria.operatorName",
  mqttUser: "aaria.mqttUser",
} as const;

export function loadRememberedWsUrl(): string {
  return localStorage.getItem(STORAGE_KEYS.wsUrl) ?? "";
}

export function saveRememberedWsUrl(url: string): void {
  localStorage.setItem(STORAGE_KEYS.wsUrl, url);
}

export function loadOperatorName(): string {
  return localStorage.getItem(STORAGE_KEYS.operatorName) ?? "";
}

export function saveOperatorName(name: string): void {
  localStorage.setItem(STORAGE_KEYS.operatorName, name);
}

export function loadRememberedMqttUser(): string {
  return localStorage.getItem(STORAGE_KEYS.mqttUser) ?? "";
}

export function saveRememberedMqttUser(user: string): void {
  localStorage.setItem(STORAGE_KEYS.mqttUser, user);
}

export function getOrCreateDeviceId(): string {
  const key = "aaria.deviceId";
  let id = sessionStorage.getItem(key);
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem(key, id);
  }
  return id;
}
